@if (rows().length > 0) {
  <div class="data-table">
    @for (row of rows(); track row.label) {
      <div class="data-row">
        <span class="data-label">{{ row.label }}</span>
        @if (row.link) {
          <a class="data-value data-link" [href]="row.link" target="_blank">{{ row.value ?? '-' }}</a>
        } @else {
          <span class="data-value">{{ row.value ?? '-' }}</span>
        }
      </div>
    }
  </div>
} @else {
  <div class="empty-state">{{ emptyText() }}</div>
}
